module.exports = __webpack_public_path__ + "static/media/Casino-Days-Two-Lines-White-BG-600x600.5d233fc4.png";